// extracted by mini-css-extract-plugin
module.exports = {"left":"splitButton_left_3LytJtZ","right":"splitButton_right_3P8iANH"};